// Routes de l'application
// Liens de téléchargement de l'application mobile
export const STORE_URLS = {
  android: 'https://play.google.com/store/apps/details?id=com.unload.kudhi',
  ios: 'https://apps.apple.com/us/app/kudhi/id6784979136',
}

export const ROUTES = {
  // Public
  HOME: '/',
  ABOUT: '/about',
  CONTACT: '/contact',
  
  // Authentication
  LOGIN: '/login',
  REGISTER: '/register',
  FORGOT_PASSWORD: '/forgot-password',
  RESET_PASSWORD: '/reset-password',
  
  // Après connexion
  LIGDI: '/kudhi-market',
  DASHBOARD: '/dashboard',
  PROFILE: '/profile',
  SETTINGS: '/settings',
  
  // Mise en relation (à adapter selon votre logique métier)
  SEARCH: '/search',
  MATCHES: '/matches',
  MESSAGES: '/messages',
  NOTIFICATIONS: '/notifications',
  
  // Création de contenu
  CREATE_POST: '/create-post',
  CREATE_VIDEO: '/create-video',
  CREATE_BANNER: '/create-banner',
  PRICING: '/pricing',
  
  // Error
  NOT_FOUND: '/404',
  UNAUTHORIZED: '/401',
  SERVER_ERROR: '/500',
}

// Rôles utilisateurs
export const USER_ROLES = {
  SUPER_ADMIN: 'Super Admin',
  ADMIN: 'Admin',
  SUPERVISEUR: 'Superviseur',
  ANIMATEUR: 'Animateur',
  TECHNICIEN: 'Technicien',
  CLIENT: 'Client',
}

// Exporter les permissions
export { PERMISSIONS, ROLES, ROLE_PERMISSIONS } from './permissions'
export { MENU_PERMISSIONS, canAccessMenu } from './menuPermissions'

// Statuts
export const STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  PENDING: 'pending',
  BLOCKED: 'blocked',
}

// Messages d'erreur
export const ERROR_MESSAGES = {
  NETWORK_ERROR: 'Erreur de connexion. Veuillez vérifier votre connexion internet.',
  UNAUTHORIZED: 'Vous devez être connecté pour accéder à cette page.',
  FORBIDDEN: "Vous n'avez pas les permissions nécessaires.",
  NOT_FOUND: 'Ressource introuvable.',
  SERVER_ERROR: 'Erreur serveur. Veuillez réessayer plus tard.',
  VALIDATION_ERROR: 'Veuillez vérifier les informations saisies.',
}

// Messages de succès
export const SUCCESS_MESSAGES = {
  LOGIN: 'Connexion réussie !',
  REGISTER: 'Inscription réussie ! Bienvenue sur LIGDI.',
  UPDATE: 'Mise à jour réussie.',
  DELETE: 'Suppression réussie.',
  SAVE: 'Enregistrement réussi.',
}

export default {
  ROUTES,
  USER_ROLES,
  STATUS,
  ERROR_MESSAGES,
  SUCCESS_MESSAGES,
}
